import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { IonButton, IonCard, IonCardContent, IonCardTitle, IonCol, IonGrid, IonInput, IonItem, IonLabel, IonList, IonRow, IonSkeletonText, IonText, ToastController } from '@ionic/angular/standalone';
import Swal from 'sweetalert2';
import { catchError, of } from 'rxjs';
import { Producto } from '../../Models/Productos';
import { Usuario } from '../../Models/usuario';
import { ApiProductosService } from '../../services/api-productos.service';
import { CarritoServiceService } from '../../services/carrito-service.service';
import { LoginService } from '../../services/login.service';
import { ServiciowishlistService } from '../../services/serviciowishlist.service';
import { HandleInpSearchService } from '../../services/handle-inp-search.service';
import { BuscadorService } from '../../services/handle-buscador.service';
import { searchResult } from '../../types/googleSearch';
import { ApiBuscadorGoogleService } from '../../services/api-buscador-google.service';

@Component({
  selector: 'app-mesa-regalos-construct',
  standalone: true,
  imports: [
    MatPaginatorModule,
    CommonModule,
    FormsModule,
    RouterModule,
    IonRow,
    IonCol,
    IonCard,
    IonList,
    IonItem,
    IonLabel,
    IonSkeletonText,
    IonCardContent,
    IonText,
    IonGrid,
    IonCardTitle,
    IonButton,
    IonInput
  ],


  templateUrl: './mesa-regalos-construct.component.html',
  styleUrls: ['./mesa-regalos-construct.component.scss'],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class MesaRegalosConstructComponent implements OnInit {


  otroId: any
  catis: any = []
  catisArreglo: any = []
  names: any = []
  startIndex: number = 1;
  sortOrder: string = '';
  public totalResultados: number = 0;
  Acribend: any = [];
  alto: any
  largo: any
  ancho: any
  tengo = ""
  meveo = 0
  peso: any
  AmericanCrafts: any = [];
  ArkonMounts: any = [];
  ArmourEtch: any = [];
  Artesprix: any = [];
  Bazzill: any = [];
  Brother: any = [];
  public grandTotal!: number;
  ColorPour: any = [];
  ColorPrint: any = [];
  ColorBok: any = [];
  Colortex: any = [];
  Corvus: any = [];
  Creality: any = [];
  Cricut: any = [];
  DCWV: any = [];
  Decofoil: any = [];
  Doodlebug: any = [];
  Eclectic: any = [];
  Ektools: any = [];
  FoilQuill: any = [];
  Forever: any = [];
  Gisarron: any = [];
  GlueDots: any = [];
  Grafimag: any = [];
  Gutermann: any = [];
  HandiPrint: any = [];
  HeidiSwapp: any = [];
  Hotronix: any = [];
  Janome: any = [];
  Kronaline: any = [];
  Lideart: any = [];
  Luminos: any = [];
  Luster: any = [];
  MagicDot: any = [];
  Metalix: any = [];
  Minc: any = [];
  Moxy: any = [];
  Oracal: any = [];
  Orafol: any = [];
  Otros: any = [];
  Quelli: any = [];
  Ranger: any = [];
  Royalsovereign: any = [];
  Sawgrass: any = [];
  Signcal: any = [];
  Silhouette: any = [];
  Siser: any = [];
  Sizzix: any = [];
  Statikmax: any = [];
  Sublimarts: any = [];
  Surebonder: any = [];
  TorchPaste: any = [];
  Tyvek: any = [];
  Varali: any = [];
  Versamark: any = [];
  WeRMemoryKeepers: any = [];
  xTool: any = [];
  Zebra: any = [];
  public txtBuscador: string = '';
  clickie = 0;

  @ViewChild('modal_wp') modal_wp!: ElementRef<HTMLInputElement>;
  modal_wpIs = false;

  id_customer: any;
  usuario!: Usuario;
  listaWishlist: any = []
  datosCliente: any = []
  nombre: any;
  apellido: any;
  correo: any;
  cargando = false;
  notiene = 0;

  //DESSSSSSSSSC PRODUCTO VARIABLEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEES
  selectedImageURL: string = "";
  id_product: any;
  public descripcion: any;
  productoData: any;
  public colorSeleccionado: string = '';
  atributos: any;
  public precioDyn: any;
  public color = 'blanco';
  items: any = [];
  descripcionsita: any;
  referenciaChida: any;
  public baseUrl: string = 'https://new.lideart.com.mx/';
  slider: any = [];
  slidervideos: any = [];
  relacionados: any = [];
  sliderOne: any;
  slideOptsOne = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true
  };

  results: searchResult = {
    kind: "",
    url: {
      type: "",
      template: ""
    },
    queries: {
      request: [
        {
          title: "",
          totalResults: "",
          searchTerms: "",
          count: 0,
          startIndex: 0,
          inputEncoding: "",
          outputEncoding: "",
          safe: "",
          cx: ""
        }
      ]
    },
    context: {
      title: ""
    },
    searchInformation: {
      searchTime: 0,
      formattedSearchTime: "",
      totalResults: "",
      formattedTotalResults: ""
    },
    items: []
  };
  query: string = '';


  searchQuery: string = '';
  catisArreglo2: any[] = [];
  public totalItems: number = 0;
  public crr_sel = 0;
  public crr_indx = 0;
  public cantidad: number = 1;
  public existencias: any;
  productoSKU: any;
  fechita = new Date();
  contenidoHTML: any;
  nuevaFecha: any;
  unidadVenta: any;
  descripcionsilla: any;
  descuento: any;
  fechaInicio: any;
  fechaFin: any;
  fechaActual: any;
  resdesc: any = [];
  descuentillo = false;
  carritoclick = 0;
  cargoprecio = false;
  email: any;
  id_product_attribute: any;
  varColorSelected: any;
  cargandoImagenes = 0;
  cargandoPrecio = 0;
  cargandoInventario = 0;
  cargandoProductoInfo = 0;
  parametros: any = [];
  descripcionsillas: any = [];
  productName: any;
  public currentItemsToShow: any = [];
  url = "https://new.lideart.com.mx/img/categoria/"
  public arrayMarcas: any = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58
  ];

  constructor(private productos: ApiProductosService,
    private activatedRoute: ActivatedRoute, private servicioWishlist: ServiciowishlistService, private usuarioService: LoginService,
    private productoService: ApiProductosService,
    private shoppingCart: CarritoServiceService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private router: Router,
    private satanizador: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
    private txtBuscadorService: HandleInpSearchService,
    private handleLoad: BuscadorService,
    public toastController: ToastController,
    public customSearchService: ApiBuscadorGoogleService,
    private renderer2: Renderer2
  ) {

  }

  ngOnInit() {
    if (!localStorage.getItem('foo')) {
      localStorage.setItem('foo', 'no reload')
      location.reload()
    } else {
      localStorage.removeItem('foo')
    }
    try {
      this.usuarioService.usuario.subscribe(res => {
        if (!res) return
        this.usuario = res;

      });
    } catch (error) {


    }
    try {
      this.productos.getSubcategoriaPorProducto(11).subscribe(datitos => {
        this.catis = datitos
        this.catisArreglo = this.catis[0].arreglo;
        // this.names = this.catis[0].arreglo.name;

        this.shoppingCart.cartItems2.subscribe(data => {
          this.items = data;
          this.totalItems = data.length;
          if (this.items) {
            this.getTotal(this.items);

          }

          // this.registraCarrito2();
        });

      })
    } catch (error) {

    }






    this.currentItemsToShow = this.arrayMarcas.slice(0, 5);
  }



  cleanBusk() {
    this.txtBuscador = '';
  }

  buscameCat(id_cat: any) {

    try {
      this.productos.getCategorias(id_cat).subscribe((Moxy: any) => {
        this.Acribend = Moxy;

        this.clickie = 1
      })

    } catch (error) {

    }




  }

  getTotal(data: any) {
    let subs = 0;

    for (const item of data) {
      subs += item.precio * item.quantity;

      this.grandTotal = subs;

    }
  }

  handleWP() {
    if (this.modal_wpIs == false) {
      this.renderer2.setStyle(this.modal_wp.nativeElement, 'display', 'flex');

      this.modal_wpIs = true
      this.meveo = 1
    } else if (this.modal_wpIs == true) {
      this.renderer2.setStyle(this.modal_wp.nativeElement, 'display', 'none');

      this.modal_wpIs = false
      this.meveo = 0;
    }
  }

  confirmarCompra(id: any, tipo: any) {

    if (tipo == "buscador") {

      const casi = id.split("/")

      let idesito

      if (casi.length == 5 || casi.length == 6) {
        const casi2 = casi[4].split("-")
        this.otroId = casi2[0];

      }

      if (casi.length == 4) {
        const casi2 = casi[3].split("-")
        this.otroId = casi2[0];
      }
    }

    if (tipo == "normal") {

      this.otroId = id;
    }






    this.cargando = true;
    this.handleWP()
    this.productoService.getDescripcionProducto(this.otroId).subscribe((data: any) => {
      try {
        this.productoData = data;
        //  this.existencias = this.productoData[0].existencia;
        this.atributos = this.productoData[0].detalles.atributos;
        //  this.precioDyn = this.productoData[0].precio;
        this.unidadVenta = this.productoData[0].unitId;
        this.descripcionsita = this.productoData[0].description;
        this.descripcionsilla = this.productoData[0].description_short;
        this.alto = this.productoData[0].height;
        this.ancho = this.productoData[0].width;
        this.largo = this.productoData[0].depth;
        this.peso = this.productoData[0].weight;
        let id_cat = this.productoData[0].id_category;
        this.cargandoProductoInfo = 1;
        var jsondescuento = {
          "descuento": this.id_product
        }
        this.productoService.getDescuento(jsondescuento).subscribe((resdesc: any) => {
          try {

            this.resdesc = resdesc;
            //console.log(this.resdesc)

            if (this.resdesc === 1) {

              this.descuentillo = false;
              this.descuento = 1;

            } else {

              this.descuentillo = true;
              this.descuento = this.resdesc;
              this.descuento = 1 - this.descuento
            }
          } catch (error) {

            this.descuentillo = true;
            this.descuento = this.resdesc;
            this.descuento = 1 - this.descuento
          }

          this.cargando = false;
          this.colorDefault()

        })
        // this.getDescripciones();
      } catch (error) {
        this.cargandoProductoInfo = 1;
        this.cargandoImagenes = 1;
        this.cargando = false;
      }
    })
    this.nuevaFecha = this.datePipe.transform(this.fechita, "MM-dd-yyyy");
  }


  seleccionacolor(nombreColor: any, id_attribute: number, id_group: number, colvar: any) {
    this.varColorSelected = colvar;
    this.colorSeleccionado = nombreColor;
    this.carritoclick = 1;
    if (document.getElementsByClassName('selected selector-color').length > 0) {
      document.getElementsByClassName('selected selector-color')[0].className =
        document
          .getElementsByClassName('selected selector-color')[0]
          .className.replace('selected', '');
    }
    var cuadro = document.getElementById('' + id_attribute);
    if (cuadro) cuadro.className = 'selected ' + cuadro.className;

    this.cambiaSku();
    this.color = document.getElementsByClassName(
      'selected selector-color'
    )[0].className;
    let colorsito = document.getElementsByClassName('selected');
    if (colorsito.length > 0) {
      this.color = '' + colorsito[0].children[0].getAttribute('title');
    }
  }
  cambiaSku() {
    try {
      var ladata = this.productoData[0];
      var variables = ladata.detalles.variables;
      if (document.getElementsByClassName('selected selector-color').length > 0) {
        var selecciones = [];
        selecciones.push({
          id_group: document
            .getElementsByClassName('selected selector-color')[0]
            .className.split('id_group_')[1]
            .split(' ')[0],
          id_attribute: document.getElementsByClassName(
            'selected selector-color'
          )[0].id,
        });
        if (document.getElementsByName('atributos').length > 0) {
          var selectores = document.getElementsByName('atributos');
          for (var i = 0; i < selectores.length; i++) {
            var sl = selectores[i];
            selecciones.push({
              id_group: sl.classList[0],
              id_attribute: (<HTMLInputElement>sl).value,
            });
          }
        }
        var pasa = true;

        for (var i = 0; i < variables.length; i++) {
          pasa = false
          var nkeys = Object.keys(variables[i].atributos)
          var aciertos = 0
          var nvalor = 0

          for (var j = 0; j < nkeys.length; j++) {
            for (var k = 0; k < selecciones.length; k++) {
              if (selecciones[k].id_group == nkeys[j]) {
                if (variables[i].atributos[selecciones[k].id_group] == selecciones[k].id_attribute) {
                  aciertos++
                }
              }
            }
          }
          if (aciertos == nkeys.length) {

            pasa = true
            nvalor = i
            i = variables.length + 10
          }

          if (pasa) {


            ladata.sku = variables[nvalor].reference;


            var lrf = document.getElementById('referencia');
            var uv = document.getElementById('unidadVenta');
            this.id_product_attribute = variables[nvalor].id_product_attribute


            if (lrf) {
              lrf.innerText = variables[nvalor].reference.replace(/-R$/, '');
              var referenciaLimpia = lrf.outerHTML.replace(/-R$/, '');
              referenciaLimpia = referenciaLimpia.split(/>/)[1].split(/</)[0];
              this.referenciaChida = referenciaLimpia;

              this.getExistencias(referenciaLimpia, 'CHIH');
              this.getPrecioUnitario(referenciaLimpia, this.unidadVenta);
              this.getExistencias2(referenciaLimpia);

              // if(uv)
              // {
              //   uv.innerText = variables[nvalor].unidadVenta.replace(/-R$/, '');
              //   var unidadventLimpia = uv.outerHTML.replace(/-R$/, '');
              //   unidadventLimpia = unidadventLimpia.split(/>/)[1].split(/</)[0];


              // }
            }
            i = variables.length + 100;
            this.crr_sel = 0;
            this.crr_indx = 0;
          }
        }
        if (!pasa) {
          if (
            this.crr_sel <=
            document.getElementsByName('atributos').length - 1
          ) {
            var elselect = document.getElementsByName('atributos')[this.crr_sel];
            if (
              (<HTMLSelectElement>elselect).options.length >
              this.crr_indx + 1
            ) {
              (<HTMLSelectElement>elselect).selectedIndex = this.crr_indx;
              this.crr_indx++;
            } else {
              this.crr_sel++;
              this.crr_indx = 0;
            }
            this.cambiaSku();
            var lrf = document.getElementById('referencia');

            var uv = document.getElementById('unidadVenta');
            this.id_product_attribute = variables[this.crr_indx].id_product_attribute


            if (lrf) {
              lrf.innerText = variables[i].reference.replace(/-R$/, '');
              var referenciaLimpia = lrf.outerHTML.replace(/-R$/, '');
              referenciaLimpia = referenciaLimpia.split(/>/)[1].split(/</)[0];
              this.referenciaChida = referenciaLimpia;

              this.getExistencias(referenciaLimpia, 'CHIH');
              this.getPrecioUnitario(referenciaLimpia, this.unidadVenta);
              this.getExistencias2(referenciaLimpia);
              // if(uv)
              // {
              //   uv.innerText = variables[i].unidadVenta.replace(/-R$/, '');
              //   var unidadventLimpia = uv.outerHTML.replace(/-R$/, '');
              //   unidadventLimpia = unidadventLimpia.split(/>/)[1].split(/</)[0];

              // this.getPrecioUnitario(referenciaLimpia,unidadventLimpia);
              // }
            }


          } else {
            this.crr_sel = 0;
            this.crr_indx = 0;
          }
        }
      }
    } catch (error) {

    }

  }

  colorDefault() {
    setTimeout(() => {



      try {
        let span = document.getElementsByClassName('id_group_2 selector-color')[0].children[0] as HTMLElement;
        if (span) {
          span.click();
        }
      } catch (error) {
        this.getExistencias(this.productoData[0].sku, 'CHIH');
        this.getPrecioUnitario(this.productoData[0].sku, this.unidadVenta);
        this.getExistencias2(this.productoData[0].sku);
      }

      try {
        let span2 = document.getElementsByClassName('id_group_7 selector-color')[0].children[0] as HTMLElement;
        if (span2) {
          span2.click();
        }
      } catch (error) {
        this.getExistencias(this.productoData[0].sku, 'CHIH');
        this.getPrecioUnitario(this.productoData[0].sku, this.unidadVenta);
        this.getExistencias2(this.productoData[0].sku);

      }




    }, 1500);


  }

  getPrecioUnitario(reference: string, medida: string) {
    this.cargando = true;
    ////console.log(reference);
    ////console.log(medida);
    this.cargandoPrecio = 0
    /*if (reference == '' || reference == null || reference == undefined || reference == 'undefined' || medida == '' || medida == null || medida == undefined || medida == 'undefined') {
      return;
    }*/
    let objetoPost = {
      // CustAccount: "C000041928",
      // InventLocationId: "CHIHCONS",
      // InventSiteId: "CHIH",
      // ItemId: reference,
      // PercentCharges: 0,
      // UnitId: medida,
      // amountQty: 1,
      // company: "ATP",
      // currencyCode: "MXN",
      // transDate: this.nuevaFecha

      "custAccount": "CL0001348",
      "itemId": reference,
      "amountQty": 1,
      "transDate": this.nuevaFecha,
      "currencyCode": "MXN",
      "inventSiteId": "CHIH",
      "inventLocationId": "CHIHCONS",
      "company": "LIN",
      "unitId": medida,
      "percentCharges": 0
    }


    this.productoService.getPrecioUnitario(objetoPost).subscribe((response: any) => {

      try {
        this.precioDyn = response.data;
        this.precioDyn = this.precioDyn * 1.16
        this.cargandoPrecio = 1;
        this.cargoprecio = true;
        this.cargando = false;
      } catch (error) {
        this.precioDyn = 0
        this.cargandoPrecio = 1;
        this.cargoprecio = true;
        this.cargando = false;
        //console.log('error precio unitario ', objetoPost);
      }


    })


  }

  getExistencias(reference: string, sitio: any) {
    this.cargando = true;
    this.cargandoInventario = 0;
    ////console.log(reference);
    //this.cargando = true;
    /*if (reference == '' || reference == null || reference == undefined || reference == 'undefined') {
      return;
    }*/
    // this.existencias = [];
    this.cargandoInventario = 0;

    this.productoService.getExistencias(reference, sitio).subscribe((response: any) => {
      let existenciasTem: any;
      existenciasTem = response;
      try {
        this.productName = response.data.productName;
        this.productName = this.productName.replace(/"/, "")
        this.cargando = false;

        if (response.data != null) {
          // this.existencias = response.data.availableOnHandQuantity;
          this.cargando = false;
          this.cargandoInventario = 1;
        }
      } catch (error) {
        this.productName = this.productoData[0].title + " " + this.color
        this.cargando = false;
        // this.existencias = 0;
        this.cargandoInventario = 1;
        //console.log('error get existencias ', reference, sitio);
      }

    });



  }

  getExistencias2(reference: any) {
    this.cargandoInventario = 0;
    this.existencias = [];
    this.productoService.getPrecioUnitario2(reference).subscribe(otroprecios => {
      try {
        let existenciasTem: any;
        existenciasTem = otroprecios;

        let invavance = otroprecios.data.availableOnHandQuantityATP;

        invavance = Math.floor(invavance * .3);

        let invlideart = otroprecios.data.availableOnHandQuantityLideart;

        this.existencias = invlideart + invavance;

        if (this.existencias > 0) {
          this.tengo = "Disponible"
        } else {
          this.tengo = "Agotado"
        }


        this.cargandoInventario = 1;
      } catch (error) {
        this.existencias = 0
        this.cargandoInventario = 1;
        this.tengo = "Agotado"
      }

    })
  }


  comprarRegalo(producto: Producto) {
    producto.existencia = this.existencias;
    producto.color = this.color;

    if (producto.color == "") {

      this.ShowError2();

    } else {

      producto.quantity = this.cantidad;
      if (this.existencias < this.cantidad) {

        this.ShowError();

      } else {
        let pasa = true;
        this.shoppingCart.cartItems2.subscribe((d: any) => {
          this.items = d;
          this.totalItems = d.length;
        });

        if (this.totalItems > 0) {
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (producto.sku == element.sku) {
              if (this.existencias < (element.quantity + producto.quantity)) {
                this.ShowError3();
                pasa = false;
              }
            }
          }
        }
        if (pasa) {
          // this.showSuccess();
          if (this.descuento == 0) {
            producto.precio = this.precioDyn;
            producto.title = this.productName

            Swal.fire({
              title: "¿Añadir Este Producto a tu Mesa de Regalos?",
              showCancelButton: true,
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar"
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.shoppingCart.addItem2(producto);

                var jsonRegalito = {
                  "id_product": producto.id_product,
                  "title": producto.title,
                  "quantity": producto.quantity,
                  "sku": producto.sku,
                  "image_link": producto.image_link,
                  "existencia": producto.existencia,
                  "medida": this.unidadVenta,
                  "alto": this.alto,
                  "largo": this.largo,
                  "ancho": this.ancho,
                  "peso": this.peso,
                  "paquete": producto.paquete,
                  "link_rewrite": producto.link_rewrite,
                  "category_rewrite": producto.category_rewrite,
                  "correo": this.usuario.usuario,
                }

                this.usuarioService.registraRegaloMesa(jsonRegalito).subscribe(registrado => {

                })
                // this.router.navigate(['/mesa-regalos-caja/'+this.id_customer]);
                this.shoppingCart.cartItems2.subscribe(data => {
                  this.items = data;
                  this.totalItems = data.length;
                  if (this.items) {
                    this.getTotal(this.items);

                  }

                  this.handleWP();
                  this.productoData = [];
                  this.tengo = "";
                  this.cargandoInventario = 0
                  this.cargandoPrecio = 0
                  // this.registraCarrito2();
                });
              }
            });

          }
          if (this.descuento > 0) {
            producto.precio = this.precioDyn * this.descuento
            producto.title = this.productName
            Swal.fire({
              title: "¿Añadir Este Producto a tu Mesa de Regalos?",
              showCancelButton: true,
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar"
            }).then((result) => {
              if (result.isConfirmed) {
                this.shoppingCart.addItem2(producto);

                var jsonRegalito = {
                  "id_product": producto.id_product,
                  "title": producto.title,
                  "quantity": producto.quantity,
                  "sku": producto.sku,
                  "image_link": producto.image_link,
                  "existencia": producto.existencia,
                  "medida": producto.medida,
                  "alto": producto.alto,
                  "largo": producto.largo,
                  "ancho": producto.ancho,
                  "peso": producto.peso,
                  "paquete": producto.paquete,
                  "link_rewrite": producto.link_rewrite,
                  "category_rewrite": producto.category_rewrite,
                  "correo": this.usuario.usuario,
                }

                this.usuarioService.registraRegaloMesa(jsonRegalito).subscribe(registrado => {

                })
                // this.router.navigate(['/mesa-regalos-caja/'+this.id_customer]);
                this.shoppingCart.cartItems2.subscribe(data => {
                  this.items = data;
                  this.totalItems = data.length;
                  if (this.items) {
                    this.getTotal(this.items);

                  }
                  this.handleWP();
                  this.productoData = [];
                  this.tengo = "";
                  this.cargandoInventario = 0
                  this.cargandoPrecio = 0
                  // this.registraCarrito2();
                });
              }
            });

          }

        }
      }

    }

  }

  onEnterCel(searchQuery: string) {
    if (searchQuery.length < 1) return
    this.txtBuscador = '';
    const currentUrl = this.router.url;
    sessionStorage.setItem('initialUrl', currentUrl);
    this.txtBuscadorService.setTxtBuscador(searchQuery);
    this.router.navigate(['/google-search/' + searchQuery]);
    //this.router.navigate(['/google-search'], { queryParams: { query: searchQuery } });
  }


  onSearchChange(query: string) {
    this.query = query;
    if (query.length < 1) {
      this.resetSearch();
      return
    }
    this.customSearchService.search(this.query, this.startIndex, this.sortOrder).pipe(
      catchError(error => {
        console.error('Error al realizar busqueda:', error);
        // Retorna un observable vacío o algún valor por defecto
        return of({
          items: [], searchInformation: {
            formattedSearchTime: "",
            formattedTotalResults: "0",
            totalResults: "0",
            searchTime: 0.0,
          }
        });
      })
    ).subscribe(response => {
      response = response as searchResult
      // console.log(response)
      this.totalResultados = Number(response.searchInformation.totalResults)
      this.results = response;

      console.log(this.results)
      if (!response.items) {
        return
      }
      this.results.items = this.results.items?.map((item: any) => ({
        ...item,
        link: this.extractPath(item.link)
      }));
    });
  }

  nextPage(): void {
    if (!this.results.queries.nextPage) return
    const startIndex = this.results.queries.nextPage[0].startIndex
    this.scrollUp();
    this.customSearchService.search(this.query, startIndex, this.sortOrder).subscribe(response => {
      if (response)
        this.results = response;
      this.results.items = this.results.items?.map((item: any) => ({
        ...item,
        link: this.extractPath(item.link)
      }));
    });

  }

  prevPage(): void {
    if (!this.results.queries.previousPage) return
    const startIndex = this.results.queries.previousPage[0].startIndex
    this.scrollUp();
    this.customSearchService.search(this.query, startIndex, this.sortOrder).subscribe(response => {
      this.results = response;
      if (!response.items) return
      this.results.items = this.results.items?.map((item: any) => ({
        ...item,
        link: this.extractPath(item.link)
      }));
    });
  }

  private resetSearch() {
    this.results.items = [];
    this.results.searchInformation = {
      formattedSearchTime: "",
      formattedTotalResults: "0",
      totalResults: "0",
      searchTime: 0.0,
    }
  }

  scrollUp(): void {

  }



  async ShowError() {
    // const toast = await this.toastController.create({
    //   message: 'Inventario Insuficiente',
    //   color: "danger",
    //   position: "top",
    //   duration: 1500

    // });
    // toast.present();

    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Inventario Insuficiente",
      // footer: '<a href="#">Why do I have this issue?</a>'
    });
  }

  async borradito() {
    // const toast = await this.toastController.create({
    //   message: 'Inventario Insuficiente',
    //   color: "danger",
    //   position: "top",
    //   duration: 1500

    // });
    // toast.present();

    Swal.fire({
      icon: "success",
      title: "Borrado!",
      text: "Producto Borrado de tu mesa de Regalos",
      // footer: '<a href="#">Why do I have this issue?</a>'
    });
  }

  async ShowError3() {
    // const toast = await this.toastController.create({
    //   message: 'No puedes llevar al Carrito mas de la Cantidad en Existencias',
    //   color: "danger",
    //   position: "top",
    //   duration: 1500

    // });
    // toast.present();
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No puedes llevar al Carrito mas de la Cantidad en Existencias",
      // footer: '<a href="#">Why do I have this issue?</a>'
    });

  }

  async ShowError2() {
    // const toast = await this.toastController.create({
    //   message: 'Necesitas Seleccionar Color',
    //   color: "danger",
    //   position: "top",
    //   duration: 1500

    // });
    // toast.present();
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Necesitas Seleccionar Color",
      // footer: '<a href="#">Why do I have this issue?</a>'
    });

  }

  onDelete(i: number) {

    this.items.splice(i, 1);
    this.shoppingCart.setCartData2(this.items);
    this.getTotal(this.items);
    this.borradito();



  }

  vaciaCarrito() {
    this.shoppingCart.deleteCart2();
  }


  guardarMesa() {
    var jsonCarrito = { "email": this.usuario.usuario, "json": JSON.stringify(this.items) };

    this.usuarioService.registraJsonMesa(jsonCarrito).subscribe(mesita => {

      this.router.navigateByUrl(`/mesa-regalos-principal`);

    })

  }

  private extractPath(url: string): string {
    try {
      const parsedUrl = new URL(url);
      return `/${parsedUrl.pathname}`;
    } catch (error) {
      // console.error('Invalid URL:', url);
      return url;
    }
  }

  onPageChange($event: PageEvent) {
    /*this.productoService.getDescuento(jsondescuento).subscribe(resdesc =>{
        this.resdesc = resdesc;
  
        if (this.resdesc === 1) {
        
          this.descuentillo = false;
          this.descuento = 1;
        }else{
        
          this.descuentillo = true;
          this.descuento = this.resdesc;
          this.descuento = 1- this.descuento
        }
    });*/
    this.currentItemsToShow = this.arrayMarcas.slice($event.pageIndex * $event.pageSize, $event.pageIndex * $event.pageSize + $event.pageSize);
  }
}
